import { createAction } from 'typesafe-actions';

export const changeRegionAction = createAction('filters/regionChanged')<number[]>();
